export default __webpack_public_path__ + "2da0cc0ca9f7ae1085c93834071d1a0a.svg";